module.exports = __webpack_public_path__ + "img/img_left.408cb7a0.jpg";